import React from 'react'
import { View, ZoomProvider } from 'oio-react'
import Helmet from 'react-helmet'
import { useParams } from 'react-router-dom'
import ContentView from 'src/components/Content/View'
import { useOrganization, usePage } from 'src/graphql/hooks'
import PageUIContext from 'src/libraries/contexts/PageUI'

const InitiativePage = () => {
   const { pageSlug } = useParams()
   const { organization } = useOrganization()
   const { page, loading: pageIsLoading } = usePage({ slug: pageSlug, withContent: true })

   if (pageIsLoading) {
      return null
   }

   return (
      // NOTE: This ZoomProvider was added for the sake of parity release only
      <ZoomProvider zoom={0.95}>
         <View float="left" width="100%" paddingVertical="30px">
            <Helmet title={`${page.title} | ${organization.name}`} />
            <PageUIContext.Provider
               value={{
                  contentMaxWidth: '100%',
                  contentPaddingLeft: '0px',
                  contentPaddingRight: '0px',
                  contentPaddingVertical: '12px'
               }}>
               <ContentView elements={page.body.elements} />
            </PageUIContext.Provider>
         </View>
      </ZoomProvider>
   )
}

export default InitiativePage
